module.exports = __webpack_public_path__ + "static/human_robot_interaction_01-19e37e64acf5ec1d80e4261c192244c9.jpg";